import script from "./AccountMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountMenu.vue?vue&type=script&setup=true&lang=ts"

import "./AccountMenu.vue?vue&type=style&index=0&id=5c4c92b0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c4c92b0"]])

export default __exports__